import { useQuery } from '@apollo/client';
import { SOCIAL_USER_SEARCH } from './social-user-search.gql';
export const useMentionQuery = (query = '') => {
    var _a, _b, _c;
    const { data, error, loading } = useQuery(SOCIAL_USER_SEARCH, {
        variables: { query },
        fetchPolicy: 'no-cache',
    });
    const users = ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.socialUserSearch) === null || _b === void 0 ? void 0 : _b.collection) === null || _c === void 0 ? void 0 : _c.reduce((users, { isMentionable, userId, user }) => {
        var _a, _b;
        if (user === null || user === void 0 ? void 0 : user.displayName) {
            const { displayName, profileImage, occupations } = user;
            users.push({
                displayName,
                isMentionable,
                occupationOrg: (_a = occupations === null || occupations === void 0 ? void 0 : occupations[0]) === null || _a === void 0 ? void 0 : _a.headline,
                profileImage: (_b = profileImage === null || profileImage === void 0 ? void 0 : profileImage[0]) === null || _b === void 0 ? void 0 : _b.url,
                userId,
            });
        }
        return users;
    }, [])) || [];
    return { users, loading, hasError: !!error };
};
//# sourceMappingURL=use-mention-query.js.map